import { Injectable } from '@angular/core';
@Injectable({
  providedIn:'root'
})

export class Globals {
    page?: string;
    pageTab?: string;
    accessLeftMenu?: string = "register";
    loaderDisplay?: string = "";
    accountOwnerName? : string;
    profilePopup? : any = {};
    profilePopupDisplay? : number = 0;
    sampleDataPopupDisplay? : number = 0;

    //Authorization variables
    code? : string;
    provider? : string;
    redirectUrl? : string;
    state? : string;

    //finance Cod Process
   codAccountOwnerName? : string ;
   ordersIds? : any = [];
   amountValues? : any = [];
}
